__turbopack_context__.v({
  "bar": "Default-module__HLE6NG__bar",
  "content": "Default-module__HLE6NG__content",
  "icon": "Default-module__HLE6NG__icon",
});
